import { RRule } from 'rrule';

import RRS from 'constants/recurrence/recurrenceRuleSimplified.const';
import withOptions from 'utils/functions/withOptions.util';
import asObject from 'utils/objects/asObject.util';
import recurrenceFirstRule from 'utils/recurrence/recurrenceFirstRule.util';

const recurrenceRuleSimplified = withOptions((options) => {
  // simplified to a simple enum because the UI can't cope with the full range of possible rules

  if (!options.string) return RRS.onlyOnce;

  const firstRule = recurrenceFirstRule(options);
  if (!firstRule) return RRS.onlyOnce;

  const { freq, interval } = asObject(firstRule.options);

  const WEEKLY = RRule.WEEKLY;
  const DAILY = RRule.DAILY;

  if (freq !== WEEKLY) return freq === DAILY ? RRS.every1Day : RRS.onlyOnce;

  if (interval === 6) return RRS.every6Weeks;
  if (interval === 4) return RRS.every4Weeks;
  if (interval === 2) return RRS.every2Weeks;

  return RRS.every1Week;
});

export default recurrenceRuleSimplified;
